"use client";
import { Track } from "@/src/lib/tracking";

import {
  isHandoffSessionActive,
  startHandoffSession,
} from "./handoffSessionStore";

/**
 * Paywall dismissed (未付费, branch B) → 启动两步未激活 App tour（取代 V3.0.3 三步 handoff）。
 * Onboarding is once-only; no localStorage handoff_seen.
 * Same-session duplicate calls are no-ops via active-session guard.
 * Caller should already be on /plan (Unlock leave navigates there first).
 */
export function startOnboardingHandoffAfterDismiss(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  if (isHandoffSessionActive()) {
    Track.log("warn", "handoff", "skip — session already active");
    return false;
  }

  startHandoffSession({ variant: "unactivated", branch: "B" });
  Track.log(
    "info",
    "handoff",
    "two-step unactivated tour started after paywall dismiss",
    {
      branch: "B",
    },
  );
  return true;
}
